import '@fancyapps/fancybox';

(function ($) {
    "use strict";
  
    // javascript code here. i.e.: $(document).ready( function(){} );
    $(document).ready(function(){
        $('[data-fancybox="image-gallery"]').fancybox({
            buttons: [
                "zoom",
                "slideShow",
                "thumbs",
                "close"
            ],
        });
    });
})(jQuery);
  
